/**
 * PrivateRoute Component
 * Route wrapper for protected pages (requires authentication)
 */

import React from "react";

import { Navigate, Outlet, useLocation } from "react-router-dom";

import { AUTH_ROUTES } from "@/features/auth/routes";
import { useAuthStore } from "@/features/auth/store/authStore";

interface PrivateRouteProps {
  children?: React.ReactNode;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const location = useLocation();

  // Not authenticated - redirect to login
  if (!isAuthenticated) {
    return (
      <Navigate
        to={AUTH_ROUTES.LOGIN}
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  // Authenticated - render content directly (full page)
  return <>{children || <Outlet />}</>;
};

export default PrivateRoute;
